import _ from 'lodash';
import { FileExtendedDetails, ValidationResult, FormField } from 'sos-common/js/commonTypes';
import { SelectBoxOption } from 'sos-common/js/components/FormControls';
import { ResearchOrderModel, researchOrderFiles } from '../models';

export function getFileNameFromId(fileId: string, files: researchOrderFiles): string {
  let filename = 'Kunde inte hitta filnamnet';
  let file = _.find(files, (o) => {
    if (!o || o.length === 0) return false;
    let val = o.find((x) => x.FileId === fileId);
    if (!val) return false;
    if (val.FileId === fileId) filename = val.OriginalFilename;
    return val.FileId === fileId;
  });
  return filename;
}

export function getAllFileNames(files: researchOrderFiles): string[] {
  let valuesArr = _.values(files);
  let fileNames = [];
  valuesArr.forEach((value) => {
    if (value?.length > 0) {
      fileNames.push(value[0].OriginalFilename);
    }
  });
  return fileNames;
}

export function allFiles2SelectBoxOptions(files: researchOrderFiles): SelectBoxOption[] {
  let selectBoxes: SelectBoxOption[] = [];
  for (const fileClasss in files) {
    if (files.hasOwnProperty(fileClasss)) {
      const element: FileExtendedDetails[] = files[fileClasss];
      if (element.length) {
        selectBoxes.push(...element.map(fileDetail2SelectBoxOption));
      }
    }
  }
  return selectBoxes;
}

export function allEthicsFiles2SelectBoxOptions(files: researchOrderFiles): SelectBoxOption[] {
  let selectBoxes: SelectBoxOption[] = [];

  const { ansokanEtik, beslutetik, ovrigtilletik, tillagansokanetik, tillagbeslutetik } = files;
  const ethicFiles = [ansokanEtik, beslutetik, ovrigtilletik, tillagansokanetik, tillagbeslutetik];
  ethicFiles.forEach((element) => {
    if (element.length) {
      selectBoxes.push(...element.map(fileDetail2SelectBoxOption));
    }
  });
  return selectBoxes;
}

export function allScopedResearchOrderFiles2SelectBoxOptions(files: researchOrderFiles): SelectBoxOption[] {
  let selectBoxes: SelectBoxOption[] = [];
  const { ansokanEtik, tillagansokanetik, forskningsplan } = files;
  const scopedFiles = [ansokanEtik, tillagansokanetik, forskningsplan];
  scopedFiles.forEach((element) => {
    if (element.length) {
      selectBoxes.push(...element.filter((x) => !!x.FileId).map(fileDetail2SelectBoxOption));
    }
  });
  return selectBoxes;
}

export function fileDetail2SelectBoxOption(fileDetail: FileExtendedDetails): SelectBoxOption {
  return {
    key: fileDetail.FileId,
    text: fileDetail.OriginalFilename,
  };
}

export function getErrorMessageFromValidationResult(validationResults: ValidationResult[]) {
  return function (formField: FormField<any>): string {
    if (!formField.isTouched) return '';
    const result = getValidationResultByFieldName(validationResults, formField.fieldName);
    return result ? result.ValidationText : '';
  };
}

export function getErrorMessageByFieldName(validationResults: ValidationResult[] = [], fieldName: string): string {
  const validation = getValidationResultByFieldName(validationResults, fieldName);
  if (validation) return validation.ValidationText;
  return '';
}

export function getErrorMessageByFieldNameAfterHitSummary(
  validationResults: ValidationResult[] = [],
  fieldName: string,
  hasHitSummary: boolean,
) {
  if (!hasHitSummary) {
    return '';
  }
  return getErrorMessageByFieldName(validationResults, fieldName);
}

export function getValidationResultByFieldName(
  validationResults: ValidationResult[] = [],
  fieldName: string,
): ValidationResult {
  if (!validationResults) return { FieldName: '', ValidationText: '' };
  fieldName = fieldName.replace('CurrentResearchOrder.', '').replace('StatisticsOrder.', '');
  return validationResults.filter((validationResult) => validationResult.FieldName === fieldName)[0];
}
// Todo this should be managed somewhere else.. putting here now for easy access.
export const fileInputAcceptedTypes =
  'application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.graphics,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.formula,text/rtf,application/rtf,text/plain,image/jpeg,image/png,image/tiff,image/bmp,image/x-bmp,image/x-ms-bmp,image/gif,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.xlsx,application/msexcel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/mspowerpoint,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const fileInputAcceptedTypesVariabellista =
  'application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.formula,text/rtf,application/rtf,text/plain,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,.xls,application/msexcel,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/mspowerpoint,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';

export function areAllFieldsErrorFree(validationResults: ValidationResult[], ...fieldNames: string[]): boolean {
  let isValid = true;
  for (let field of fieldNames) {
    const errorMsg = getErrorMessageByFieldName(validationResults, field);
    if (errorMsg !== '') {
      isValid = false;
      break;
    }
  }
  return isValid;
}

export function mandatoryIfNotOnlyDeceased(researchOrder: ResearchOrderModel) {
  return researchOrder.StudyPopulation.OnlyDeceased !== 'Ja';
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
